import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation, } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, } from '@angular/material/core';
import { MatDatepicker } from '@angular/material/datepicker';
import { TimeUtils } from '@shared/utils/time.utils';
import moment, { Moment } from 'moment';
import { DateSelectorService } from './date-selector.service';

const FORMATS = {
  parse: {
    dateInput: 'MM/YYYY',
  },
  display: {
    dateInput: 'MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-date',
  templateUrl: './date-selector.component.html',
  styleUrls: ['./date-selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
    { provide: MAT_DATE_FORMATS, useValue: FORMATS },
  ],
})
export class DateSelectorComponent implements OnInit {

  @ViewChild('datePicker')
  public picker: MatDatepicker<Moment>;

  public isMobile = false;

  public date = new FormControl(moment());

  constructor(private service: DateSelectorService) {}

  ngOnInit(): void {
    this.service.__trigger.subscribe(() => {
      this.picker.open();
      this.move();
    });
    this.isMobile = window.innerWidth <= 767;
  }

  // onChange(value: any) {
  //   this.service.__result.next(value.target.value._d);
  // }

  setMonthAndYear(normalizedMonthAndYear: Moment) {
    const ctrlValue = this.date.value!;
    ctrlValue.month(normalizedMonthAndYear.month());
    ctrlValue.year(normalizedMonthAndYear.year());
    this.date.setValue(ctrlValue);
    this.service.__result.next(ctrlValue.toDate())
    this.picker.close();
  }

  private async move() {
    if (!this.isMobile) {
      await TimeUtils.sleep(20);
      const popup: HTMLDivElement = document.querySelector('.mat-datepicker-popup');
      popup.style.left = `${this.service.__mousePosition[0]}px`;
      popup.style.top = `${this.service.__mousePosition[1]}px`;
    }
  }

}
